import store from '../../..';
import { TApiaFilter } from '../../../../types';
import { makeCustomEvent } from '../../../../utils/dom';

export default function notifyRequiredFilters(
  listId: string,
  newFilters?: TApiaFilter[],
): TApiaFilter[] {
  // Hallar todos los filtros requeridos sin valor
  // Hacer update de cada uno
  // Helper function to check if a value is empty (undefined or empty string)
  const isEmpty = (value: any) => value === undefined || value === '';

  // Helper function to add or remove error based on condition
  const setError = (
    filter: TApiaFilter,
    errorField: keyof TApiaFilter,
    condition: boolean,
    errorMessage: string = '',
  ): TApiaFilter => {
    return {
      ...filter,
      [errorField]: condition ? errorMessage : undefined,
    };
  };

  const missingFilters =
    (newFilters
      ? newFilters.map((apiaFilter) => {
          if (['date', 'D'].includes(apiaFilter.type as string)) {
            if (apiaFilter.required) {
              if (
                apiaFilter.dateFromRequired &&
                isEmpty(apiaFilter.currentValue)
              ) {
                return setError(
                  apiaFilter,
                  'errorFrom',
                  true,
                  'Filtro requerido',
                );
              } else if (
                apiaFilter.dateRequired &&
                isEmpty(apiaFilter.currentValue) &&
                isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(apiaFilter, 'error', true, 'Filtro requerido');
              } else if (
                apiaFilter.dateToRequired &&
                isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(
                  apiaFilter,
                  'errorTo',
                  true,
                  'Filtro requerido',
                );
              } else if (
                apiaFilter.dateFromRequired &&
                !isEmpty(apiaFilter.currentValue)
              ) {
                return setError(apiaFilter, 'errorFrom', false);
              } else if (
                apiaFilter.dateRequired &&
                !isEmpty(apiaFilter.currentValue) &&
                !isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(apiaFilter, 'error', false);
              } else if (
                apiaFilter.dateToRequired &&
                !isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(apiaFilter, 'errorTo', false);
              } else {
                return apiaFilter;
              }
            } else {
              return apiaFilter;
            }
          } else {
            if (apiaFilter.required) {
              if (isEmpty(apiaFilter.currentValue)) {
                return setError(apiaFilter, 'error', true, 'Filtro requerido');
              } else {
                return setError(apiaFilter, 'error', false);
              }
            } else {
              return apiaFilter;
            }
          }
        })
      : store.getState().listSlice.lists[listId].filters?.map((apiaFilter) => {
          if (['date', 'D'].includes(apiaFilter.type as string)) {
            if (apiaFilter.required) {
              if (
                apiaFilter.dateFromRequired &&
                isEmpty(apiaFilter.currentValue)
              ) {
                return setError(
                  apiaFilter,
                  'errorFrom',
                  true,
                  'Filtro requerido',
                );
              } else if (
                apiaFilter.dateRequired &&
                isEmpty(apiaFilter.currentValue) &&
                isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(apiaFilter, 'error', true, 'Filtro requerido');
              } else if (
                apiaFilter.dateToRequired &&
                isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(
                  apiaFilter,
                  'errorTo',
                  true,
                  'Filtro requerido',
                );
              } else if (
                apiaFilter.dateFromRequired &&
                !isEmpty(apiaFilter.currentValue)
              ) {
                return setError(apiaFilter, 'errorFrom', false);
              } else if (
                apiaFilter.dateRequired &&
                !isEmpty(apiaFilter.currentValue) &&
                !isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(apiaFilter, 'error', false);
              } else if (
                apiaFilter.dateToRequired &&
                !isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(apiaFilter, 'errorTo', false);
              } else {
                return apiaFilter;
              }
            } else {
              return apiaFilter;
            }
          } else {
            if (apiaFilter.required) {
              if (isEmpty(apiaFilter.currentValue)) {
                return setError(apiaFilter, 'error', true, 'Filtro requerido');
              } else {
                return setError(apiaFilter, 'error', false);
              }
            } else {
              return apiaFilter;
            }
          }
        })) ?? [];

  if (missingFilters.some((current) => typeof current.error === 'string')) {
    const firstMissingFilterId = missingFilters.find(
      (current) => typeof current.error === 'string',
    )?.id;

    const filterElement = document.querySelector(
      `[name="${firstMissingFilterId as string}"]`,
    ) as HTMLElement;
    if (filterElement) {
      filterElement.dispatchEvent(makeCustomEvent('focus'));
      filterElement.focus();
    }
  }

  return missingFilters;
}
